import { InjectionToken, isDevMode } from '@angular/core';

/**
 * Use ANIMATION_CONFIGURATION to turn angular animations on/off depending on the environment.
 * For example, for e2e environment, the animations are turned off to speed up Protractor tests.
 *
 * @see https://angular.io/api/animations/trigger
 */
export const ANIMATION_CONFIGURATION = new InjectionToken<boolean>('animationConfiguration');

export const ANIMATION_CONFIG_PROVIDER_FACTORY = (): boolean => isDevMode();
